// extracted by mini-css-extract-plugin
module.exports = {"wrapperRow":"CourierReportComponent_wrapperRow__NZd1V","wrapperColumn":"CourierReportComponent_wrapperColumn__dSOka","wrapperAction":"CourierReportComponent_wrapperAction__14oS0"};